// Debug utility for inspecting the current state of filters and data
import { loadFromLocalStorage } from '../utils/localStorage';

export const debugFilters = (filters, clientNames, filteredHacks) => {
  console.group('Filter Debug Info');
  
  // Get raw data from localStorage
  const rawData = loadFromLocalStorage('growthHacksData', []);
  console.log('Raw data from localStorage:', rawData);
  console.log('Unique clients from raw data:', [...new Set(rawData.map(hack => hack.Client))]);
  
  // Current filter state
  console.log('Current filters:', filters);
  console.log('Available client names:', clientNames);
  console.log('Filtered hacks:', filteredHacks);
  
  // Check for specific client
  if (filters.clientName && filters.clientName !== 'All') {
    const matchingHacks = rawData.filter(hack => hack.Client === filters.clientName);
    console.log(`Hacks matching client "${filters.clientName}":`, matchingHacks);
    
    // Compare case-insensitive
    const caseInsensitiveMatches = rawData.filter(
      hack => hack.Client && hack.Client.toLowerCase() === filters.clientName.toLowerCase()
    );
    if (caseInsensitiveMatches.length !== matchingHacks.length) {
      console.warn('Case sensitivity issue detected!', caseInsensitiveMatches);
    }
    
    // Check for whitespace issues
    const trimmedMatches = rawData.filter(
      hack => hack.Client && hack.Client.trim() === filters.clientName.trim()
    );
    if (trimmedMatches.length !== matchingHacks.length) {
      console.warn('Whitespace issue detected!', trimmedMatches);
    }
  }
  
  console.groupEnd();
};
